<template>
    <notes reference-type="project" :reference-id="$route.params.slug" />
</template>

<script>
    import Notes from '../../../components/Notes'

    export default {
        components: { Notes }
    }
</script>